import io from "socket.io-client"
import Dispatcher from "./dispatcher.js"
import OnEvent from "./on-event.js"

/**
 * Socket Client js
 **/
export default class Socket {
  constructor(store, config, Vue, router) {
    this.store = store
    this.config = config
    this.Vue = Vue
    this.router = router
    this.inited = false
  }

  init() {
    if (this.inited) return

    this.connection = io(`//${this.config.socket.connection}/`, {
      transports: ["websocket"]
    })

    this.dispatcher = new Dispatcher(this.connection, this.store, this.router)
    OnEvent(this.connection, this.store, this.dispatcher)
    this.inited = true
  }

  disconnect() {
    this.connection.disconnect()
    this.inited = false
  }
}
